import { getCurrentLocale, getRawRequest } from '../../../utils'
import type { ExportFileResult, ReportExportFormat } from '../types/reportExport'
import { parseContentDispositionFilename } from './parseContentDispositionFilename'

const EXPORT_FORMAT_MIME: Record<ReportExportFormat, string> = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export const fetchExportFile = async (
  path: string,
  format: ReportExportFormat,
  fallbackFileName: string,
): Promise<ExportFileResult> => {
  const response = await getRawRequest(path, {
    Accept: EXPORT_FORMAT_MIME[format],
    'accept-language': getCurrentLocale(),
  })
  const fileName = parseContentDispositionFilename(response.headers.get('content-disposition')) ?? fallbackFileName

  return {
    blob: await response.blob(),
    fileName,
  }
}
